import * as moment from 'moment';

export class DateFormatValueConverter {
	toView(value: any) {
		let date: string = '';
		date = moment(value).format('MM/DD/YYYY');

		if (date === 'Invalid date')
			return '';

		return date;
	}
}
